import React, { useEffect, useState } from "react";
import { Alert, Container, Row, Button, Col, Tabs, Tab } from "react-bootstrap";
import CustomButton from "../../../common/CustomButton";
import { DeleteIcon, EditIcon } from "../../../../assets/svg/svg-icons";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteLiveOffer,
  getApi,
  getLiveOfferMonthCount,
} from "../../../../actions/structure.action";
import { tableStructures } from "../../../../helpers/table-structures";
import CustomTable from "../../common/CustomTable";
import LiveOfferCard from "../../common/LiveOfferCard";
import "./index.css";
import isEmpty from "../../../../utils/is-Empty";
import { useDialog } from "../../../../helpers/useDialog";

const LiveOffers = ({ mainClass }) => {
  const dispatch = useDispatch();
  const { alert, confirm, DialogModal } = useDialog();
  const [showOffersMode, setShowOffersMode] = useState(false);
  const [currentOfferObj, setCurrentOfferObj] = useState({});
  const [subscriptionFeatures, setSubscriptionFeatures] = useState(null);
  const [monthlyCountRes, setMonthlyCountRes] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);
  const [tabKey, setTabKey] = useState("active");
  const [activeOffers, setActiveOffers] = useState([]);
  const [inactiveOffers, setInactiveOffers] = useState([]);

  const { liveOffers, userSubscriptionInfo } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    setErrorMessage(null);
    getApi("getLiveOffer", dispatch);
    getLiveOfferMonthCount(dispatch).then((response) => {
      if (response) {
        setMonthlyCountRes(response);
      }
    });
  }, [dispatch]);

  useEffect(() => {
    if (monthlyCountRes && monthlyCountRes?.payload?.success === false) {
      setErrorMessage(monthlyCountRes?.payload?.message);
    }
  }, [monthlyCountRes]);

  useEffect(() => {
    setShowOffersMode(false);
    // Separate active and inactive offers
    if (liveOffers && liveOffers.data && liveOffers.data.length > 0) {
      const active = liveOffers.data.filter((offer) => offer.status === 1);
      const inactive = liveOffers.data.filter((offer) => offer.status === 0);
      setActiveOffers(active);
      setInactiveOffers(inactive);

      if (active.length < 1) {
        setShowOffersMode(true);
      }
    }
  }, [liveOffers]);

  useEffect(() => {
    if (!isEmpty(userSubscriptionInfo?.data?.sellerInfo?.subscriptionFeatures)) {
      setSubscriptionFeatures(userSubscriptionInfo?.data?.sellerInfo?.subscriptionFeatures);
    }
  }, [userSubscriptionInfo]);

  const emptyTableMsg = (
    <span className="mt-4 d-block">
      There are no records to show.{" "}
      {monthlyCountRes && monthlyCountRes?.payload?.success === true && (
        <Button
          variant="link"
          className="p-0"
          onClick={() => {
            setErrorMessage(null);
            setShowOffersMode(true);
            setCurrentOfferObj({});
          }}
        >
          Create Offer
        </Button>
      )}
    </span>
  );

  const offerTabs = () => {
    return (
      <Tabs id="offer-tabs" activeKey={tabKey} onSelect={(k) => setTabKey(k)} className="mb-0">
        <Tab eventKey="active" title={`Active Offers (${activeOffers.length})`}>
          <CustomTable
            CustomTopClass="mx-0"
            emptyTableMsg={emptyTableMsg}
            data={activeOffers}
            columns={tableStructures.live_offers}
            enableTopToolbar={true}
            enableRowActions={true}
            initialState={{
              columnPinning: {
                right: ["mrt-row-actions"],
              },
              sorting: [
                { id: "startDate", desc: true }, // default sort by startDate DESC
              ],
            }}
            positionActionsColumn={"last"}
            renderRowActions={({ row }) => {
              return (
                row.original.status === 1 && (
                  <div className="table-action-box">
                    <CustomButton
                      buttonClasses="icon-action-btn"
                      onClick={() => deleteLiveOffer(row.original.id, dispatch, confirm)}
                    >
                      <DeleteIcon />
                    </CustomButton>
                  </div>
                )
              );
            }}
            renderTopToolbarCustomActions={({ table }) => (
              <>
                <h4>{"Active Offers"}</h4>
                {monthlyCountRes && monthlyCountRes?.payload?.success === true && (
                  <CustomButton
                    buttonClasses="icon-add-btn"
                    onClick={() => {
                      setErrorMessage(null);
                      setShowOffersMode(true);
                      setCurrentOfferObj({});
                    }}
                  >
                    {"Create"}
                  </CustomButton>
                )}
              </>
            )}
          />
        </Tab>
        <Tab eventKey="inactive" title={`Inactive Offers (${inactiveOffers.length})`}>
          <CustomTable
            CustomTopClass="mx-0"
            emptyTableMsg={emptyTableMsg}
            data={inactiveOffers}
            columns={tableStructures.live_offers}
            enableTopToolbar={true}
            enableRowActions={false}
            initialState={{
              columnPinning: {
                right: ["mrt-row-actions"],
              },
              sorting: [
                { id: "startDate", desc: true }, // default sort by startDate DESC
              ],
            }}
            renderTopToolbarCustomActions={({ table }) => (
              <>
                <h4>{"Inactive Offers"}</h4>
                {monthlyCountRes && monthlyCountRes?.payload?.success === true && (
                  <CustomButton
                    buttonClasses="icon-add-btn"
                    onClick={() => {
                      setErrorMessage(null);
                      setShowOffersMode(true);
                      setCurrentOfferObj({});
                    }}
                  >
                    {"Create"}
                  </CustomButton>
                )}
              </>
            )}
          />
        </Tab>
      </Tabs>
    );
  };

  return (
    <Container className="m-0 p-0">
      {DialogModal}
      {errorMessage && (
        <Row className="mx-0 p-0 mt-2 mb-2">
          <Col md={12}>
            <Alert variant="danger" className="mb-0">
              <ul className="m-0 p-0 list-unstyled">
                <li key={"index-01"} className="d-flex align-items-start">
                  <span className="me-2 text-danger">✔</span>
                  <span>{errorMessage}</span>
                </li>
              </ul>
            </Alert>
          </Col>
        </Row>
      )}

      <Row className={mainClass}>
        {showOffersMode || liveOffers.data?.length < 1 ? (
          <Container className="seller-live-offer-create-form modal-custom-class  ">
            <LiveOfferCard
              offer={currentOfferObj}
              closeMode={setShowOffersMode}
              listEmpty={liveOffers?.length > 0 ? false : true}
              setErrorMessage={setErrorMessage}
              setMonthlyCountRes={setMonthlyCountRes}
            />
          </Container>
        ) : (
          <>{offerTabs()}</>
        )}
      </Row>
    </Container>
  );
};

export default LiveOffers;
